export const pushNotificationsReportLocation = "/reports/notifications";
